import { toast } from 'react-toastify';
import { useActions } from './features/login';

export const BASE_URL = process.env.REACT_APP_BACKEND_IP ? process.env.REACT_APP_BACKEND_IP : '';

export const refreshToken = () => {
    var axios = require('axios');
    var config = {
        method: 'post',
        url: BASE_URL + '/refresh/',
        data: JSON.stringify({ 'refresh': localStorage.getItem('refreshToken') })
    };

    axios(config)
        .then(function (response) {
            localStorage.setItem(response.data.access)
        })
        .catch(function (error) {
            console.log(error);
            window.location = '/';
        });

}
let moment = require('jalali-moment');
moment.locale('fa');
export const convertTimestap = (d, t) => {
    if (t) {

        return moment(d.year + "/" + d.month + '/' + d.day).add(t.hour, 'H').add(t.minute, 'm').unix();
    }
    else {
        return moment(d.year + "/" + d.month + '/' + d.day).unix();
    }
}
export const convertDate = (timestamp) => {
    let m = moment(timestamp * 1000)
    return { year: parseInt(m.format('YYYY')), month: parseInt(m.format('MM')), day: parseInt(m.format('DD')) }
}
export const convertDateFarsi = (timestamp) => {
    try {
        const faDate = new Intl.DateTimeFormat("fa", {
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "numeric"
        }).format(timestamp);
        return faDate
    }
    catch {
        return ''
    }
}
export const convertDateStr = (timestamp, withTime, withSecond) => {
    try {
        if (withTime) {

            if (withSecond)
                return moment(timestamp * 1000).format('YYYY/MM/DD HH:mm:ss');

            return moment(timestamp * 1000).format('YYYY/MM/DD HH:mm');
        }
        return moment(timestamp * 1000).format('YYYY/MM/DD');
    }
    catch {
        return ''
    }
}

const instance = require('axios');

instance.interceptors.response.use(
    response => response,
    error => {

        const originalRequest = error.config;
        if (localStorage.getItem('accessToken') == 'undefined' || localStorage.getItem('refreshToken') == 'undefined') {
            localStorage.clear()
        }
        // Prevent infinite loops

        if (error && (
            error.response?.status === 401 ||
            error.response?.status === 422)
            && originalRequest.url === BASE_URL + '/refresh/') {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            const { setLogin } = useActions();
            setLogin({ user: {}, isLogin: false })
            return Promise.reject(error);
        }
        if (error?.response?.status === 403) {
            toast.error('دسترسی غیرمجاز', { closeButton: false })
            return
        }
        if ((error.response?.status === 401 ||
            error.response?.statusText === "UNAUTHORIZED") ||
            error.response?.status === 422
        ) {
            if (localStorage.getItem('accessToken') == 'undefined' || localStorage.getItem('refreshToken') == 'undefined') {
                localStorage.clear()
            }
            const refresh = localStorage.getItem('refreshToken');
            if (refresh && refresh !== null) {

                var config = {
                    method: 'post',
                    url: BASE_URL + '/refresh/',
                    data: { 'refresh': localStorage.getItem('refreshToken') }
                };

                return instance(config)
                    .then(function (response) {
                        localStorage.setItem('accessToken', response.data.access);
                        instance.defaults.headers['Authorization'] = "Bearer " + response.data.access;
                        originalRequest.headers['Authorization'] = "Bearer " + response.data.access;
                        if (localStorage.getItem('accessToken') == 'undefined' || localStorage.getItem('refreshToken') == 'undefined') {
                            localStorage.clear()
                        }
                        return instance(originalRequest);
                    })
                    .catch(function (error) {
                        console.log(error);
                        const { setLogin } = useActions();
                        setLogin({ user: {}, isLogin: false })
                        Promise.reject(error)
                    });

            } else {
                console.log("Refresh token not available.")
                //window.location = '/'
                const { setLogin } = useActions();
                setLogin({ user: {}, isLogin: false })
            }
        }
        // specific error handling done elsewhere
        //setLogin({ user: {}, isLogin: false })
        return Promise.reject(error);
    }
);
export const instanceAxios = instance;
export function base64ToArrayBuffer(base64) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
}
export function saveByteArray(reportName, byte) {
    var blob = new Blob([byte], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    var fileName = reportName;
    link.download = fileName;
    link.click();
};
function getPath(obj, givenKey, givenValue) {
    let matches = [];
    for (var key in obj) {
        if (obj[key] && typeof obj[key] === "object") {
            var result = getPath(obj[key], givenValue, givenKey);
            if (result) {
                result.unshift(key)
                matches.push(...result);
            }
        } else if (obj[key] === givenValue && key === givenKey) {
            matches.push(key);
        }
    }

    return matches;
}
function findVal(object, key) {
    var value;
    Object.keys(object).some(function (k) {
        if (k === key) {
            value = object[k];
            return true;
        }
        if (object[k] && typeof object[k] === 'object') {
            value = findVal(object[k], key);
            return value !== undefined;
        }
    });
    return value;
}

export function findItemInObject(obj, parse) {
    let res = []
    var vars = getPath(obj);
    for (const i of vars)
        if (i.startsWith(parse))
            res.push({ field: i, val: findVal(obj, i) })

    return res
}
export function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}